/**
 * Traduit les codes d'erreur de l'edge fn `visio-room-summarize` en texte
 * tuteur (calque `room-errors.ts`). Le corps d'une réponse non-2xx est
 * `{ error: <code>, message? }` — cf. `errorToResponse` (`v2-generation-runtime`).
 */

const MESSAGES: Record<string, string> = {
  no_messages: 'Le chat de ce rendez-vous est vide : il n’y a rien à résumer.',
  no_room: 'Ce rendez-vous n’a pas eu de salle vidéo : il n’y a rien à résumer.',
  forbidden: 'Seul le professeur de ce rendez-vous peut générer le résumé.',
  unauthorized: 'Ta session a expiré. Reconnecte-toi puis réessaie.',
  invalid_input: 'Les instructions sont invalides (entre 10 et 4000 caractères).',
  budget_exceeded: 'Le budget IA du jour est atteint. Réessaie demain ou préviens un admin.',
  llm_invalid_output: 'L’IA a renvoyé une réponse inexploitable. Réessaie dans un instant.',
};

const FALLBACK = 'La génération du résumé a échoué. Vérifie ta connexion et réessaie.';

export function translateSummaryError(code: string | null | undefined): string {
  return (code && MESSAGES[code]) || FALLBACK;
}

/** Extrait le code métier du corps d'une erreur `functions.invoke` (contexte = Response). */
export async function extractInvokeErrorCode(error: unknown): Promise<string | undefined> {
  const ctx = (error as { context?: { json?: () => Promise<unknown> } } | null)?.context;
  if (!ctx || typeof ctx.json !== 'function') return undefined;
  try {
    const parsed = (await ctx.json()) as { error?: unknown } | null;
    return typeof parsed?.error === 'string' ? parsed.error : undefined;
  } catch {
    return undefined;
  }
}
